<div id="app-bar">
    
    <div id="foo" class="font-title">
        <button mat-icon-button (click)="toggleNav()" id="menu-button">
            <mat-icon>menu</mat-icon>
        </button>

       <img (click)="closeNavSm()" class="app-bar-logo" src="../../assets/Logo/svg/Logo_8.svg" routerLink="/">

    </div>

    <div class="lang-btn-container">
        <button id="lang-switcher" class="lang-button" (click)="switchLang()">{{('langName.' + language) | translate }}</button>
    </div>

    <ul class="nav-items" [class.visible]="navOpenedSm">
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showTeachersTabs" (click)="showStorySessions()">{{'header.storySession' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showTeachersTabs" (click)="showQuizSessions()">{{'header.quizSessions' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showTeachersTabs" (click)="showFindStudents()">{{'header.findStudents' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showTeachersTabs" (click)="showMyStudents()">{{'header.myStudents' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showAdminTabs" (click)="showUploadQuestion()">{{'header.uploadQuestions' | translate}}</li>
        <li *ngIf="showStudentLevelInfo && !showTeachersTabs && !showAdminTabs" [innerHTML]="'header.experiencePoints' | translate: { expPoints: studentInfo?.expPoints }"></li>
        <li *ngIf="showStudentLevelInfo && !showTeachersTabs && !showAdminTabs && language === 'ar'" [innerHTML]="'header.readingLevel' | translate: { imgSrc: studentCurrentReadingLevelImage }"></li>
        <li *ngIf="showStudentLevelInfo && !showTeachersTabs && !showAdminTabs && language === 'en'" [innerHTML]="'header.readingLevel' | translate: { imgSrc: studentCurrentReadingLevelImageAr }"></li>
        <!-- <li class="cursor-pointer" *ngIf="showStudentLevelInfo && !showTeachersTabs && !showAdminTabs && language === 'en'" (click)="showMyAssignments()">{{'header.myAssignments' | translate}}</li>
        <li class="cursor-pointer" *ngIf="showStudentLevelInfo && !showTeachersTabs && !showAdminTabs && language === 'ar'" (click)="showMyAssignments()">{{'header.myAssignments' | translate}}</li> -->
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showAdminTabs" routerLink="/upload">{{'header.uploadBooks' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showAdminTabs" routerLink="/editStory">{{'header.editStoryBooks' | translate}}</li>
        <li class="cursor-pointer" (click)="closeNavSm()" *ngIf="showAdminTabs" routerLink="/editQuiz">{{'header.editQuiz' | translate}}</li>
    </ul>

    <div class="navbar-profile-section">
        <mat-spinner *ngIf="!isAvatarSVGReady" diameter="40"></mat-spinner>
        <div *ngIf="isAvatarSVGReady" [innerHTML]="safeAvatarSVG" class="avatar-image-container navbar-profile-dropdown-profile-image"></div>
        <div class="profile-info-username">
            <span>{{username}}</span>
        </div>
        <div class="navbar-relative-container font-title">
                <a  id="navbar-profile-btn">
                    <mat-icon id="profile-dropdown-icon" (click)="toggleProfileDropdown()">expand_more</mat-icon>
                </a>
                <ul *ngIf="showProfileDropdown" class="navbar-profile-dropdown-section">
                    <li>
                        <a>
                            <div class="top-bar">
                                <button class="navbar-dropdown-btn profile-btn btn btn-primary"  id="logout-btn" (click)="profile()">{{'header.myProfile' | translate}}</button>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a>
                            <div *ngIf="!showTeachersTabs" class="top-bar">
                                <button class="navbar-dropdown-btn profile-btn btn btn-primary"  id="level-up-btn" (click)="levelUpPage()">{{'header.levelUp' | translate}}</button>
                            </div>
                            <div *ngIf="!showTeachersTabs && !showAdminTabs" class="top-bar">
                                <button class="navbar-dropdown-btn profile-btn btn btn-primary"  id="view-request-btn" (click)="viewRequestPage()">{{'header.viewRequest' | translate}}</button>
                                <button class="navbar-dropdown-btn profile-btn btn btn-primary"  id="my-assignment-btn" (click)="showMyAssignments()">{{'header.myAssignments' | translate}}</button>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a>
                            <div class="top-bar">
                                <button class="navbar-dropdown-btn profile-btn btn btn-primary"  id="level-up-btn" (click)="AboutPage()">{{'header.aboutUs' | translate}}</button>
                            </div>
                        </a>
                    </li>
                    <br>
                    <li>
                        <a href="#">
                            <div class="top-bar">
                                <button class="navbar-dropdown-btn btn btn-primary" (click)="logout()" id="logout-btn">{{'header.logout' | translate}}</button>
                            </div>
                        </a>
                    </li>
                </ul>
        </div>
    </div>
</div>
